import { makeAutoObservable, autorun } from 'mobx';
import { TCartItem } from '../types';

import { getCartData, saveCartData } from '../utils/helpers';

class CartStore {
  items: TCartItem[] = []

  choosingForCartItemId = null

  loadCartData() {
    this.items = getCartData();
  }

  saveCartData() {
    saveCartData(this.items);
  }

  addItemToCart(item) {
    this.items.push(item);
  }

  checkItemExisting(inputItemId) {
    return !!(getCartData().find(({id}) => id === inputItemId));
  }

  clearCart() {
    this.items = [];
    saveCartData();
  }

  deleteItem(i) {
    this.items = this.items.filter((_, j) => i !== j);
    saveCartData();
  }

  haveThirdPartyItem = () => {
    const thirdPartyItems = (this.items?.filter(({isThirdParty}) => !!isThirdParty)) || [];
    const thirdPartyAdditionalItems = ((this.items?.reduce((reducer, {additionalItem}) => [...reducer, ...additionalItem], []))?.filter(({isThirdParty}) => !!isThirdParty)) || [];

    return !!(([...thirdPartyItems, ...thirdPartyAdditionalItems])?.length);
  }

  deinit = null;

  init() {
    this.deinit = autorun(() => {
      this.saveCartData();
    });
  }

  constructor() {
    this.loadCartData();
    makeAutoObservable(this);
  }
}

export const cartStore = new CartStore();
